import { ApolloClient, InMemoryCache } from "@apollo/client";

const myCompanyClient = new ApolloClient({
  uri: `${process.env.REACT_APP_BASE_URL}/my-company`,
  cache: new InMemoryCache(),
});

export { myCompanyClient };
